import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { LazyIcon } from "./LazyIcon";

interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
  variant?: "default" | "compact";
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  actionLabel,
  onAction,
  actionIcon,
  variant = "default",
}) => {
  const isCompact = variant === "compact";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: isCompact ? "auto" : "100%",
        minHeight: isCompact ? 200 : 400,
        p: isCompact ? 2 : 4,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          color: "text.secondary",
          mb: isCompact ? 1 : 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon || (
          <LazyIcon
            name="NoDataIcon"
            sx={{
              fontSize: isCompact ? 48 : 64,
              opacity: 0.5,
            }}
          />
        )}
      </Box>

      <Typography
        variant={isCompact ? "h6" : "h5"}
        gutterBottom
        sx={{
          fontWeight: 500,
          color: "text.secondary",
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: isCompact ? 2 : 3,
            maxWidth: 400,
          }}
        >
          {description}
        </Typography>
      )}

      {actionLabel && onAction && (
        <Button
          variant="contained"
          color="primary"
          onClick={onAction}
          startIcon={actionIcon || <LazyIcon name="AddIcon" />}
          size={isCompact ? "small" : "medium"}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};
